// extracted by mini-css-extract-plugin
export default {"BdroLoginRoot":"bdroLogin-module_BdroLoginRoot_zsUDD"};